import { TvProvider } from '@/tv/TvProvider'
import { Cabinet } from '@/components/Cabinet'
import { Remote } from '@/components/Remote'
import { Dust } from '@/components/Dust'
import type { Channel } from '@/tv/types'
import './global.css'
import styles from './App.module.css'

export default function App({ channels }: { channels: Channel[] }) {
  return (
    <TvProvider channels={channels}>
      <main className={styles.void}>
        <div className={styles.ambient} />
        <div className={styles.haze} />
        <div className={styles.floorPool} />
        <Cabinet />
      </main>
      <Dust />
      <Remote />
    </TvProvider>
  )
}
